import { Model } from "pinia-orm";

export default class BaseInterpretation extends Model {
  static entity = "baseInterpretations";
  static primaryKey = "uuid";

  static fields() {
    return {
      uuid: this.uid(""),
      project: this.attr(null),
      investigationPlans: this.attr([]),
      analysisResults: this.attr([]),
      referenceValues: this.attr([]),
      interpretation: this.attr(null),
      complementaryInterpretations: this.attr([]),
      legends: this.attr([]),
    };
  }
}
